import { Button, Container, TextField, Typography } from "@mui/material";
import { Grid, Paper } from "@mui/material";
import { Key, useState } from "react";
import { toast } from "react-toastify";

import { DeviceGridKey, DeviceModel, returnDeviceGridKeys } from "../../models/DeviceModel";
import ResponseModel from "../../models/ResponseModel";
import DeviceService from "../../services/devices/DeviceService";
import { hasApiError } from "../../utils/Utils";

import { style } from "./ReturnDevice.style";

type ReturnDeviceProps = {
  returningDevice: DeviceModel | undefined;
  setReturningOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getDevices: () => Promise<void>;
};

const ReturnDevice = (props: ReturnDeviceProps): JSX.Element => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  if (!props.returningDevice) {
    return (
      <Paper style={style.paper}>
        <Typography variant="h3" style={style.title}>
          Nincs kiválasztott eszköz
        </Typography>
      </Paper>
    );
  }

  const returningDevice: DeviceModel = props.returningDevice;

  // on returning the device
  const onReturn = async (): Promise<void> => {
    setIsSubmitting(true);

    const loadingToastId = toast.loading("Visszavétel folyamatban...");
    const response: ResponseModel = await DeviceService.deviceTakeBack(returningDevice.id);

    setIsSubmitting(false);

    if (hasApiError(response)) {
      toast.dismiss(loadingToastId);
      return;
    } else {
      toast.update(loadingToastId, { render: "Sikeres visszavétel", type: "success", isLoading: false, autoClose: 4000 });
      void props.getDevices();
      props.setReturningOpen(false);
    }
  };

  return (
    <Paper style={style.paper}>
      <Typography variant="h3" style={style.title}>
        Biztosan vissza akarod venni az eszközt?
      </Typography>
      <Grid container spacing={4}>
        {returnDeviceGridKeys
          .filter((gridKey: DeviceGridKey): boolean => gridKey.inputHidden !== true)
          .map((gridKey: DeviceGridKey, i: Key): JSX.Element => {
            return (
              <Grid item key={i} md={gridKey.md ?? 3} sm={gridKey.sm ?? 6} xs={gridKey.xs ?? 12}>
                <Typography style={style.gridLabel} align={gridKey.align ?? "left"}>
                  {gridKey.label}
                </Typography>
                <TextField
                  fullWidth
                  disabled={gridKey.inputDisabled ?? false}
                  value={(returningDevice as Record<string, unknown>)[gridKey.key] ?? ""}
                  variant="standard"
                />
              </Grid>
            );
          })}
      </Grid>

      <Container style={style.buttonContainer}>
        <Button variant="contained" onClick={(): void => props.setReturningOpen(false)}>
          Mégse
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={(): void => {
            void onReturn();
          }}
          disabled={isSubmitting}
        >
          Visszavétel
        </Button>
      </Container>
    </Paper>
  );
};

export default ReturnDevice;
